import { initMacros } from "@notemeal/shared-utils-macro-protocol";
import { getExchangeAmountsMacros } from "../ExchangeAmount/utils";
export const getMealTemplateMacroTargets = (mealTemplate) => {
    return mealTemplate.__typename === "ExchangeMealTemplate"
        ? getExchangeAmountsMacros(mealTemplate.exchangeTargets || [])
        : mealTemplate.cho !== null && mealTemplate.pro !== null && mealTemplate.fat !== null
            ? initMacros(mealTemplate.cho, mealTemplate.pro, mealTemplate.fat)
            : null;
};
export const getMealTemplateExchangeTargets = (mealTemplate) => {
    return mealTemplate.__typename === "ExchangeMealTemplate" ? mealTemplate.exchangeTargets : [];
};
//# sourceMappingURL=utils.js.map